import { SelfTestAnswers } from "../../../../components/self-test/model/SelfTestAnswers";

export const result = (answers: SelfTestAnswers) => {
    const ans = Object.values(answers);
    const parent_risk = ans[1] === 'A';

    let risk = 0;
    for (let i = 2; i < ans.length; i++) {
        if (ans[i] === 'A') {
            risk += 1;
        }
    }

    return { parent_risk, risk }
}